import React from 'react';
import {
  INSTALLMENT_STATUS_FILTERS,
  INSTALLMENT_STATUS_FILTER_ALL,
} from '../../../core/constants/financial';

// Barra de filtro de situação (Todos/Pendente/Atrasado/Pago) reutilizada
// pelas listagens financeiras. value é um array de status; vazio = todos.
const StatusFilter = ({ value, onChange }) => {
  const isAll = value.length === 0;

  const isActive = (key) => {
    if (key === INSTALLMENT_STATUS_FILTER_ALL) return isAll;
    return value.includes(key);
  };

  const handleClick = (key) => {
    if (key === INSTALLMENT_STATUS_FILTER_ALL) {
      onChange([]);
      return;
    }
    if (value.includes(key)) {
      onChange(value.filter((k) => k !== key));
    } else {
      onChange([...value, key]);
    }
  };

  return (
    <div className="fd-period-filters">
      <span className="fd-period-filters-label">Situação:</span>
      {INSTALLMENT_STATUS_FILTERS.map((s) => (
        <button
          key={s.key}
          type="button"
          className={`fd-period-btn ${isActive(s.key) ? 'fd-period-btn--active' : ''}`}
          onClick={() => handleClick(s.key)}
        >
          {s.label}
        </button>
      ))}
    </div>
  );
};

export default StatusFilter;
